import axios from 'axios';
import { getHostname } from './server/server' 

const hostname = getHostname();
const path = '/v2/schedule';

async function getSchedules(customerId) {
    const res = await axios.get(`${hostname}${path}?customerId=${customerId}`);
    return res.data;
}

async function deleteSchedule(customerId, scheduleId) {
    const res = await axios.delete(`${hostname}${path}?customerId=${customerId}&scheduleId=${scheduleId}`);
    return res.data;
}

async function updateSchedule(customerId, schedule) {
    const res = await axios.put(`${hostname}${path}?customerId=${customerId}`, schedule);
    return res.data;
}

async function createSchedule(customerId, schedule) {
    const res = await axios.post(`${hostname}${path}?customerId=${customerId}`, schedule);
    return res.data;
}

function compareScheduleTimesAsc(a, b) {
    if (parseInt(a.time) < parseInt(b.time)) {
        return -1;
    }
    if (parseInt(a.time) > parseInt(b.time)) {
        return 1;
    }
    return 0;
}

function compareScheduleTimesDesc(a, b) {
    if (parseInt(a.time) > parseInt(b.time)) {
        return -1;
    }
    if (parseInt(a.time) < parseInt(b.time)) {
        return 1;
    }
    return 0;
}

export {
    getSchedules,
    updateSchedule,
    createSchedule,
    deleteSchedule,
    compareScheduleTimesAsc,
    compareScheduleTimesDesc
}